import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Email and password are required");
      return;
    }
    setLoading(true);
    const r = await login(email.trim(), password);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } else {
      toast.error(r.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6 font-body relative overflow-hidden">
      <div className="gold-orb a" style={{ width: 320, height: 320, top: "-10%", left: "-5%" }} />
      <div className="gold-orb b" style={{ width: 260, height: 260, bottom: "-10%", right: "-5%" }} />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative w-full max-w-md bg-[#1A1A1A] border border-[#D4AF37]/25 rounded-3xl p-8 sm:p-10 shadow-[0_30px_80px_-20px_rgba(212,175,55,0.18)]"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <Logo size={84} variant="mark" />
          <h1 className="mt-5 font-display text-2xl font-bold text-white">Admin Login</h1>
          <p className="mt-1 text-sm text-white/55">M&amp;C Clean Fresh control panel</p>
        </div>

        <label className="text-xs uppercase tracking-wider text-white/60 mb-2 block">Email</label>
        <div className="relative mb-5">
          <Mail className="w-4 h-4 text-[#D4AF37] absolute left-4 top-1/2 -translate-y-1/2" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="input-dark pl-11"
            placeholder="admin@mccleanfresh.com"
            autoComplete="username"
          />
        </div>

        <label className="text-xs uppercase tracking-wider text-white/60 mb-2 block">Password</label>
        <div className="relative mb-7">
          <Lock className="w-4 h-4 text-[#D4AF37] absolute left-4 top-1/2 -translate-y-1/2" />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="input-dark pl-11"
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="btn-gold w-full !py-3.5"
        >
          {loading ? (<><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</>) : "Sign In"}
        </button>

        <a
          href="/"
          className="mt-5 block text-center text-xs text-white/45 hover:text-[#D4AF37] tracking-widest uppercase"
        >
          ← Back to site
        </a>
      </form>
    </div>
  );
}
